import React, { PropsWithChildren, useContext } from 'react';
import { ViewManagerContext } from 'contexts/ViewManagerContext';

import ForcePortrait from './ForcePortrait';

// The lobby is portrait-locked on mobile-landscape (see ForcePortrait), but the
// app-level overlay panels (CashierPanel, etc.) are mounted outside the lobby's
// wrapper — so without this they'd keep the device's landscape orientation,
// showing at a different angle than the rotated lobby behind them.
//
// This wraps such an overlay so it adopts the SAME portrait rotation, but ONLY
// while the portrait-locked lobby is the active view. Over a landscape table the
// table view isn't locked, so the overlay is left untouched. The rotated layer
// is pointer-transparent (the overlays are always mounted and slide off-screen
// when closed) and sits above the lobby/table panels (SlideContainer uses z 1–2).
const LOBBY_OVERLAY_Z = 1000;

const LobbyOverlayLock: React.FC<PropsWithChildren> = ({ children }) => {
  const { activeView } = useContext(ViewManagerContext);
  return (
    <ForcePortrait enabled={activeView === 'lobby'} zIndex={LOBBY_OVERLAY_Z} transparentToPointer>
      {children}
    </ForcePortrait>
  );
};

export default LobbyOverlayLock;
